@if (data.title) {
  <h1>{{ data.title }}</h1>
}

<form
  (ngSubmit)="onSubmit($event)"
  [data]="data"
  [formGroup]="control"
  uiFormConditionalFields
>
  <ng-template [groupItem]="data" [groupControl]="control" uiFormDynamicElements></ng-template>
</form>
